import { createFeedLoader } from './InfiniteScroll/adapter';

export const init = () => {
    (window as any).Common = (window as any).Common || {};
    (window as any).Common.createFeedLoader = createFeedLoader;
};
